// Org picker for users who belong to more than one pulse org.
// Hidden entirely for single-org users.
import { Building2, Check, ChevronsUpDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useMyOrgs, useActiveOrgId, useSwitchOrg } from '@/lib/pulse/orgs';

export function OrgSwitcher() {
  const { data: orgs } = useMyOrgs();
  const activeOrgId = useActiveOrgId(orgs);
  const switchOrg = useSwitchOrg();

  if (!orgs || orgs.length < 2) return null;

  const active = orgs.find((o) => o.org_id === activeOrgId) ?? orgs[0];

  return (
    <div className="px-3 pt-3">
      <DropdownMenu>
        <DropdownMenuTrigger className="w-full flex items-center gap-2 px-2.5 py-2 rounded-md border border-border bg-muted/40 text-left text-xs hover:bg-muted transition-colors">
          <Building2 className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
          <span className="flex-1 truncate font-medium">{active.name}</span>
          <ChevronsUpDown className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56 bg-popover z-50">
          {orgs.map((o) => (
            <DropdownMenuItem
              key={o.org_id}
              onSelect={() => {
                if (o.org_id !== active.org_id) switchOrg(o.org_id);
              }}
              className="text-xs"
            >
              <Check
                className={
                  o.org_id === active.org_id
                    ? 'h-3.5 w-3.5 mr-2 opacity-100'
                    : 'h-3.5 w-3.5 mr-2 opacity-0'
                }
              />
              <span className="truncate">{o.name}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
